import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { links } from 'utils/featureToggles'

interface Props {
  tab: AdministrationAllowedInterestRatesTab
}

export enum AdministrationAllowedInterestRatesTab {
  WALLETS_CONFIGURATION = 'Wallets Configuration',
  THRESHOLDS = 'Thresholds',
  ELIGIBILITY_CRITERIA = 'Eligibility Criteria',
}

export const AdministrationAllowedInterestRatesNavigation: React.FC<Props> = (props) => {
  const navigate = useNavigate()

  const handleTabClick = (tab: string) => {
    switch (tab) {
      case AdministrationAllowedInterestRatesTab.WALLETS_CONFIGURATION:
        return navigate(links.administrationInterestRateConfigControls.url)

      case AdministrationAllowedInterestRatesTab.THRESHOLDS:
        return navigate(links.administrationInterestRateThresholds.url)

      case AdministrationAllowedInterestRatesTab.ELIGIBILITY_CRITERIA:
        return navigate(links.administrationInterestRateEligibility.url)

      default:
        return navigate(links.administrationInterestRateConfigControls.url)
    }
  }

  return (
    <div>
      <Tabs value={props.tab} onValueChange={handleTabClick} className='mt-2'>
        <TabsList>
          <TabsTrigger value={AdministrationAllowedInterestRatesTab.WALLETS_CONFIGURATION}>
            {AdministrationAllowedInterestRatesTab.WALLETS_CONFIGURATION}
          </TabsTrigger>

          <TabsTrigger value={AdministrationAllowedInterestRatesTab.THRESHOLDS}>
            {AdministrationAllowedInterestRatesTab.THRESHOLDS}
          </TabsTrigger>

          <TabsTrigger value={AdministrationAllowedInterestRatesTab.ELIGIBILITY_CRITERIA}>
            {AdministrationAllowedInterestRatesTab.ELIGIBILITY_CRITERIA}
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  )
}
